import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'service-provider-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-provider-profile.component.html',
  styleUrl: './service-provider-profile.component.css'
})
export class ServiceProviderProfileComponent {
  activeTab: string = 'posts'; // Default tab is "Posts"

  // Sample data with image and video media in posts
  posts = [
    { 
      title: "Post 1", 
      content: "This is the first post.", 
      media: { type: 'image', url: 'https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D' }
    },
    { 
      title: "Post 2", 
      content: "This is the second post.", 
      media: { type: 'video', url: 'https://www.w3schools.com/html/movie.mp4' }
    },
    { 
      title: "Post 3", 
      content: "This is the third post, without media.",
      media: { type: 'image', url: 'src/assests/images/ravi.webp' }
    }
  ];

  issues = [
    { title: "Issue 1", description: "Bug in the login system." },
    { title: "Issue 2", description: "Payment gateway not working." }
  ];

  services = [
    { name: "Web Development", description: "Building modern websites and apps." },
    { name: "SEO Optimization", description: "Improve search engine ranking." }
  ];

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  @Input() profileData: any = {
    name: "Reena Devi",
    nickname: "RD",
    profileType: "Carpenter",
    profileImage: "https://plus.unsplash.com/premium_photo-1664474619075-644dd191935f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW1hZ2V8ZW58MHx8MHx8fDA%3D",
    mobileNumber: "123-456-7890",
    address: "123 Main St, Sample City",
    location: "Sample Location"
  };

  selectedImage: string = '';

  openImageModal(image: string) {
    this.selectedImage = image;
  }
  
}
